import type { OrderStatus } from '@multicrm/shared';
import { ORDER_STATUS_TONE } from '@multicrm/shared';
import type { ReactNode } from 'react';
import { cn } from '../../lib/cn';

export type Tone = 'amber' | 'blue' | 'violet' | 'cyan' | 'green' | 'gray' | 'red';

/*
  Цвет статуса приходит из токенов темы, а не хардкодом: в тёмной теме это
  приглушённая подложка со светлым текстом, в светлой — наоборот.
*/
const TONE_STYLE: Record<Tone, string> = {
  amber: 'bg-[var(--tone-amber-bg)] text-[var(--tone-amber)]',
  blue: 'bg-[var(--tone-blue-bg)] text-[var(--tone-blue)]',
  violet: 'bg-[var(--tone-violet-bg)] text-[var(--tone-violet)]',
  cyan: 'bg-[var(--tone-cyan-bg)] text-[var(--tone-cyan)]',
  green: 'bg-[var(--tone-green-bg)] text-[var(--tone-green)]',
  gray: 'bg-[var(--tone-gray-bg)] text-[var(--tone-gray)]',
  red: 'bg-[var(--tone-red-bg)] text-[var(--tone-red)]',
};

export function Badge({
  tone = 'gray',
  children,
  className,
}: {
  tone?: Tone;
  children: ReactNode;
  className?: string;
}) {
  return (
    <span
      className={cn(
        'rounded-chip inline-flex items-center px-2 py-0.5 text-[12px] leading-5 font-medium whitespace-nowrap',
        TONE_STYLE[tone],
        className,
      )}
    >
      {children}
    </span>
  );
}

export function StatusBadge({ status, label }: { status: OrderStatus; label: string }) {
  return <Badge tone={ORDER_STATUS_TONE[status]}>{label}</Badge>;
}

export function trackingStatusTone(status: string): Tone {
  const lower = status.toLowerCase();
  if (
    lower.includes('відмов') ||
    lower.includes('поверн') ||
    lower.includes('не з') ||
    lower.includes('скасо')
  )
    return 'red';
  if (lower.includes('одерж') || lower.includes('достав') || lower.includes('отриман'))
    return 'green';
  if (lower.includes('прибу') || lower.includes('очікує')) return 'amber';
  if (lower.includes('відправ') || lower.includes('дорозі')) return 'blue';
  if (lower.includes('створен') || lower.includes('нов')) return 'gray';
  return 'violet';
}

export function TrackingBadge({ status, className }: { status: string; className?: string }) {
  return (
    <Badge tone={trackingStatusTone(status)} className={className}>
      {status}
    </Badge>
  );
}
